import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { BRAND, WHATSAPP_NUMBER } from "../lib/constants";

const SiteSettingsContext = createContext(null);

const DEFAULT_CONTACT = {
  phone: "+91 93556 62555",
  email: "care@aarmira.in",
  whatsapp: WHATSAPP_NUMBER,
  address: "India",
};

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({ logo_url: BRAND.logo, banners: [], contact: DEFAULT_CONTACT });

  const refresh = useCallback(() => {
    api
      .get("/site-settings")
      .then((r) =>
        setSettings({
          logo_url: r.data.logo_url || BRAND.logo,
          banners: r.data.banners || [],
          contact: r.data.contact || DEFAULT_CONTACT,
        })
      )
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteSettingsContext.Provider value={{ settings, refresh }}>{children}</SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
